var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrailerIconDarkGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 20,
    viewBox: "0 0 50 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1140 -950) translate(882 850) translate(203 69) translate(55 31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M38.28 14.897c-.698-1.435-2.169-2.424-3.871-2.424-1.913 0-3.534 1.248-4.093 2.974h-15.81c-.316-1.647-1.222-2.355-3.29-2.525H0V0h49.892v15.447h-3.649c-.56-1.726-2.18-2.974-4.092-2.974-1.703 0-3.174.99-3.871 2.424z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.409,
    cy: 16.774,
    r: 1,
    stroke: "#BBB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.151,
    cy: 16.774,
    r: 1,
    stroke: "#BBB",
    strokeWidth: 5
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerIconDarkGrey);
export default __webpack_public_path__ + "static/media/trailer_icon_dark_grey.24f86ae38b23c627b6d18d771fde73af.svg";
export { ForwardRef as ReactComponent };